import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-down_line2",
  "use": "vab-icon-down_line2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-down_line2\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.7072 15.7072C12.3167 16.0977 11.6835 16.0977 11.293 15.7072L5.63616 10.0503C5.24563 9.65984 5.24563 9.02668 5.63616 8.63615C6.02668 8.24563 6.65985 8.24563 7.05037 8.63615L12.0001 13.5859L16.9498 8.63615C17.3404 8.24563 17.9735 8.24563 18.3641 8.63615C18.7546 9.02668 18.7546 9.65984 18.3641 10.0503L12.7072 15.7072Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol